import React from 'react';
import '../css/MainContent.css';
import '../css/AshiatochoContent.css';

function AshiatochoContent() {
  return (
    <div id="ashiatocho-content" className="content">
      <article className="ashiatocho-page" aria-labelledby="ashiatocho-title">
        <section className="ashiatocho-hero">
          <div className="ashiatocho-hero-copy">
            <p className="ashiatocho-kicker">水瓜書房のモバイルアプリ</p>
            <h1 id="ashiatocho-title">モバイルアプリ『あしあと帖』をリリースします</h1>
          </div>
          <img className="ashiatocho-hero-mark" src="/images/feature_graphic_1024_500.png" alt="" aria-hidden="true" />
        </section>

        <section className="ashiatocho-section">
          <p>
            あしあと帖は、目標や習慣を続けたい人が、同じ目的を持つユーザーと一緒に日々の進捗を記録・共有できるモバイルアプリです。
          </p>
          <p>
            同じ目標を持つ人たちが集まる「こみち」に参加し、1日1回その日の成果をポストできます。ストレッチ、運動、勉強、楽器の練習など、日々の小さな一歩をあしあととして残していきましょう。
          </p>
        </section>

        <section className="ashiatocho-section ashiatocho-links" aria-label="関連リンク">
          <dl>
            <div>
              <dt>Privacy Policy / プライバシーポリシー</dt>
              <dd>
                <a href="https://oww2-legal.suikashobo.com/privacy/">
                  https://oww2-legal.suikashobo.com/privacy/
                </a>
              </dd>
            </div>
            <div>
              <dt>Terms of Service / 利用規約</dt>
              <dd>
                <a href="https://oww2-legal.suikashobo.com/terms/">
                  https://oww2-legal.suikashobo.com/terms/
                </a>
              </dd>
            </div>
            <div>
              <dt>提供者</dt>
              <dd>水瓜書房</dd>
            </div>
          </dl>
        </section>
      </article>
    </div>
  );
}

export default AshiatochoContent;
